import { factoryService, getJsonRequest } from '@chilecompra/react-kit/requests'
import { REACT_APP_API_BASE_SELLER_URL } from '../config/settings/environment'

/**
 * Gets the list of income brackets.
 */
export const getBusinessIncomeBrackets = factoryService(() =>
  getJsonRequest(`${REACT_APP_API_BASE_SELLER_URL}/v1/usuario-temporal/tramo-empresa`)
)

/**
 * Gets the list of states of the country.
 */
export const getStates = factoryService(() => getJsonRequest(`${REACT_APP_API_BASE_SELLER_URL}/v1/geografia/region`))

/**
 * Gets the list of districts of a state.
 */
export const getDistricts = factoryService(({ stateID }) =>
  getJsonRequest(`${REACT_APP_API_BASE_SELLER_URL}/v1/geografia/region/${stateID}/comuna`)
)
